import { render } from "./BatchUploadLogsDetails.vue?vue&type=template&id=6acac13e&ts=true"
import script from "./BatchUploadLogsDetails.vue?vue&type=script&lang=ts"
export * from "./BatchUploadLogsDetails.vue?vue&type=script&lang=ts"

import "./BatchUploadLogsDetails.vue?vue&type=style&index=0&id=6acac13e&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__